/* eslint-disable @typescript-eslint/strict-boolean-expressions */
// Librerias
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useForm } from 'react-hook-form';

// Contextos
import { useSubCategorie, useUpdateSubCategorie } from '../../../hooks/useSubCategories';

// Hooks

// Componentes
import UpdateSubCategoriesForm from './UpdateSubCategoriesForm';
import Modal from '../../Modal';

// Imagenes

// Estilos

// Types
import { type ThemeContextType } from '../../../types/ThemeContext';

interface Props {
  isShowingModal: boolean;
  handleClick: () => void;
  OptionID: string | null;
  theme: ThemeContextType['theme'];
}

/**
 * Descripción: Modal que contiene el formulario para crear/actualizar una categoria.
 *
 * Implementación: Descripción sobre cómo puedes implementar el componente.
 *
 * Bugs: Qué bugs se han presentado y como se solucionan.
 */

const UpdateCategoriesModal = ({
  isShowingModal,
  handleClick,
  theme,
  OptionID,
}: Props): JSX.Element => {
  // Estados

  // Contextos

  // Hooks
  const { data } = useSubCategorie(OptionID);
  const { updatedSubCategorie, updateSubCategorie } = useUpdateSubCategorie();

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();

  // Funciones

  // UseEffects
  useEffect(() => {
    if (updatedSubCategorie.isLoading) {
      toast.loading('Enviando...');
    }

    if (updatedSubCategorie.data) {
      updatedSubCategorie.reset();
      reset();
      handleClick();
    }
  }, [updatedSubCategorie]);

  // Renders
  return (
    <>
      {data ? (
        <Modal show={isShowingModal} theme={theme}>
          <UpdateSubCategoriesForm
            theme={theme}
            errors={errors}
            control={control}
            register={register}
            actualData={data}
            handleClick={handleClick}
            handleSubmit={handleSubmit}
            updateSubCategorie={updateSubCategorie}
          />
        </Modal>
      ) : null}
    </>
  );
};

export default UpdateCategoriesModal;
